import CompetitorTracking from './competitor-tracking';

export default CompetitorTracking